import { GenIcon } from '../helpers/IconBase.es.js';

const ChevronForwardFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 512 512", fill: "none" },
    child: [
      { tag: "title", attr: {}, child: [] },
      {
        tag: "polyline",
        attr: {
          points: "184 112 328 256 184 400",
          strokeWidth: "48px",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "currentColor"
        }
      }
    ]
  })(props);
};

export { ChevronForwardFilled };
